import React from 'react';
import { Facebook, Instagram, Twitter, Linkedin, Youtube, Phone, Mail, MapPin, Globe, MessageCircle } from 'lucide-react';

const quickLinks = ['Tiles', 'Bathware', 'Digital Visualizer', 'Projects', 'Blogs', 'Warranty'];
const corporate = ['Our Story', 'Chairman Message', 'News & Media', 'Foundation', 'Career', 'Gallery'];

export default function Footer() {
  return (
    <footer className="bg-[#0f0f0f] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-5">
            <div className="bg-white rounded-full p-1 inline-flex">
              <img src="/images/logo.png" alt="Indian Ceramic" className="h-16 w-16 object-contain rounded-full" />
            </div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed mb-5 font-light">
            Indian Ceramic believes in continuous development and growth. We innovate and craft premium vitrified tiles and bathware that redefine modern living for homes across the globe.
          </p>
          <div className="flex items-center gap-3">
            {[
              { Icon: Facebook, href: 'https://www.facebook.com/FactoryExporter', label: 'Facebook' },
              { Icon: Instagram, href: 'https://www.instagram.com/indianceramic_/', label: 'Instagram' },
              { Icon: Twitter, href: '#', label: 'Twitter' },
              { Icon: Linkedin, href: 'https://www.linkedin.com/in/vivek-bhai-9a9320207/', label: 'LinkedIn' },
              { Icon: Youtube, href: '#', label: 'YouTube' },
            ].map(({ Icon, href, label }, i) => (
              <a
                key={i}
                href={href}
                target={href.startsWith('http') ? '_blank' : undefined}
                rel={href.startsWith('http') ? 'noreferrer' : undefined}
                aria-label={label}
                className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-[#7a1a2a] hover:border-[#7a1a2a] transition-colors"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.25em] text-[#e6c98f] mb-5">Quick Links</h4>
          <ul className="space-y-3">
            {quickLinks.map((l) => (
              <li key={l}><a href="#" className="text-sm text-white/70 hover:text-white transition-colors">{l}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.25em] text-[#e6c98f] mb-5">Corporate</h4>
          <ul className="space-y-3">
            {corporate.map((l) => (
              <li key={l}><a href="#" className="text-sm text-white/70 hover:text-white transition-colors">{l}</a></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-[0.25em] text-[#e6c98f] mb-5">Contact Us</h4>
          <p className="text-sm text-white/70 leading-relaxed mb-4 font-light flex gap-3">
            <MapPin className="w-4 h-4 text-[#e6c98f] shrink-0 mt-0.5" />
            <span>Office: 203, Empire 36, Second Floor, Mahendranagar, Morbi - 363642, Gujarat, India</span>
          </p>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-3 text-white/80">
              <Phone className="w-4 h-4 text-[#e6c98f]" /> +91 9016905858
            </li>
            <li className="flex items-center gap-3 text-white/80">
              <Phone className="w-4 h-4 text-[#e6c98f]" /> +91 9979111925
            </li>
            <li className="flex items-center gap-3 text-white/80">
              <MessageCircle className="w-4 h-4 text-[#e6c98f]" /> Skype: vivek.bhai1
            </li>
            <li className="flex items-center gap-3 text-white/80 break-all">
              <Mail className="w-4 h-4 text-[#e6c98f] shrink-0" /> export@indianceramictile.com
            </li>
            <li className="flex items-center gap-3 text-white/80 break-all">
              <Mail className="w-4 h-4 text-[#e6c98f] shrink-0" /> indiancbusiness@gmail.com
            </li>
            <li className="flex items-center gap-3 text-white/80">
              <Globe className="w-4 h-4 text-[#e6c98f]" />
              <a href="https://www.indianceramictile.com" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">www.indianceramictile.com</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 px-6 md:px-10 py-5 text-xs text-white/60 flex flex-col md:flex-row items-center justify-between gap-2">
        <span>&copy; {new Date().getFullYear()} Indian Ceramic. All Rights Reserved</span>
        <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
      </div>
    </footer>
  );
}
